import styled from 'styled-components';

export const MiniCardStyles = styled.div`
  overflow: hidden;

  .shape {
    display: flex;

    &.no-border-radius {
      border-radius: 0;
    }

    &.borders {
      border-bottom: 1px solid #cccccc;
    }

    &.hovered {
      cursor: pointer;
    }

    &.desktop {
      padding: 7px 12px 7px 7px;
    }

    &.laptop {
      padding: 14px 12px 14px 14px;
    }

    &.tablet {
      padding: 11px 8px;
    }

    &.mobile {
      flex-direction: column;
      padding: 8px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  .date {
    margin-right: 8px;
  }

  .favorites-button {
    margin-top: 6px;
  }

  &.desktop {
    margin-left: 16px;
  }

  &.desktop:not(.purchase),
  &.laptop:not(.purchase) {
    margin-left: 16px;
  }

  &.tablet:not(.purchase) {
    margin-left: 8px;
  }

  &.mobile:not(.purchase) {
    margin-top: 4px;
  }
`;

export const TopContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CentralContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
`;

export const RightContainer = styled.div`
  flex: 1;
  max-width: 170px;
  text-align: right;
`;

export const ItemParameters = styled.div`
  &.complex-advert {
    margin-bottom: 10px;
  }

  .mobile-price-geo {
    margin-top: 10px;
  }
`;
